import React from "react";
import { Lock } from "lucide-react";

/** Locked state for a paid Ponesi service the restaurant is not entitled to.
 * Informational only — no purchase flow, no pricing, no activation from the panel.
 * Entitlement state always comes from the backend (GET /api/restaurant/{rid}/features). */
export function FeatureLocked({ feature, title, children }) {
  return (
    <div data-testid={`feature-locked-${feature}`} className="max-w-xl">
      <div className="bg-white rounded-2xl border p-6 text-center">
        <div className="w-12 h-12 rounded-2xl bg-slate-100 flex items-center justify-center mx-auto">
          <Lock size={22} className="text-slate-400" />
        </div>
        <h2 className="font-display font-black text-xl mt-3 text-slate-700">{title}</h2>
        <p data-testid={`feature-locked-msg-${feature}`} className="text-sm text-slate-500 mt-1">
          {title} je dodatna Ponesi usluga.
        </p>
        <p className="text-sm text-slate-400 mt-0.5">Kontaktirajte Ponesi za aktivaciju.</p>
        {children}
      </div>
    </div>
  );
}
